import React, { ReactElement } from 'react';
import styled from 'styled-components';

export const VideoWrapper = styled.div`
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
  position: relative;
  .player {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
  }
`;

const Video = ({ autoplay, youtubeUrl }) => {
  return youtubeUrl ? (
    <VideoWrapper>
      <iframe
        className="player"
        width="100%"
        height="100%"
        src={`${youtubeUrl}&autoplay=${autoplay}`}
        frameBorder="0"
      />
    </VideoWrapper>
  ) : (
    ((false as unknown) as ReactElement)
  );
};

export default Video;
